import { Id } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { Linker, LinkedList } from "../linkers/types";
import { mapError } from "../utils/mapError";

function getList(httpClient: HttpClient, linker: Linker) {
  return (taskId: Id) =>
    httpClient
      .sendHttpRequest<LinkedList>({
        endpoint: `/activities/${taskId}?projection=activityDetailsProjection`,
        method: HttpMethods.GET,
      })
      .then((list) =>
        linker
          .linkList(list)
          .then((list) =>
            linker
              .linkProject(list.project)
              .then((project) => ({ ...list, project })),
          )
          .then((list) => ({
            ...list,
            project: list.project,
            zone: list.project.zone,
          })),
      )
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { getList };
